import { IconMail as TablerIconMail } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconMail = /*#__PURE__*/ createOutlineIcon(TablerIconMail, 'IconMail');
